import { EntryTypeEnum } from 'generated/graphql-gateway';
import { ILocalizedMenuEntry, IMainMenuNode, PosServiceMode } from 'state/unified-menu/types';
import {
  getEntryPriceOrZero,
  getMainMenuNodeType,
  mapImageResourceToSanityImage,
} from 'state/unified-menu/utils';

/**
 * Builds a display-only main-menu node from a catalog/store entry without
 * availability filtering — used to inject an unavailable deeplink item into
 * its section list.
 */
export function createMainMenuNodeFromEntry(
  entry: ILocalizedMenuEntry,
  posServiceMode: PosServiceMode = 'pickup'
): IMainMenuNode {
  return {
    id: entry.id,
    type: getMainMenuNodeType(entry.type),
    name: entry.name?.locale ?? entry.id,
    image: {
      resource: mapImageResourceToSanityImage(entry.image?.resource ?? ''),
      description: entry.image?.altText?.locale ?? '',
    },
    children: [],
    product:
      entry.type === EntryTypeEnum.ITEM ||
      entry.type === EntryTypeEnum.COMBO ||
      entry.type === EntryTypeEnum.PICKER
        ? {
            price: getEntryPriceOrZero(entry, posServiceMode),
            calories: entry.nutrition?.calories?.def ?? entry.nutrition?.calories?.min ?? 0,
          }
        : undefined,
  };
}
